import { Controller } from "@hotwired/stimulus"

// Star Rating Controller
// Progressive left-to-right star fill with hover preview and click selection
// Maintains underlying radio button for form submission
export default class extends Controller {
  static targets = ["star", "input"]
  static values = {
    rating: { type: Number, default: 0 }
  }

  connect() {
    this.updateStars(this.ratingValue)
  }

  // Hover preview - temporarily fill stars
  hover(event) {
    const starIndex = parseInt(event.currentTarget.dataset.starIndex)
    this.updateStars(starIndex)
  }

  // Mouse leave - restore selected rating
  unhover() {
    this.updateStars(this.ratingValue)
  }

  // Click selection - permanently fill stars and select radio button
  select(event) {
    const starIndex = parseInt(event.currentTarget.dataset.starIndex)
    this.ratingValue = starIndex

    // Select corresponding radio button for form submission
    const radioButton = this.inputTargets.find(input =>
      parseInt(input.value) === starIndex
    )
    if (radioButton) {
      radioButton.checked = true
    }

    this.updateStars(starIndex)
  }

  // Keyboard navigation - select star with Enter/Space
  keydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      this.select(event)
    }
  }

  // Update visual state of all stars (filled vs unfilled)
  updateStars(rating) {
    this.starTargets.forEach((star, index) => {
      const starIndex = index + 1
      const svg = star.querySelector("svg")

      if (starIndex <= rating) {
        // Filled state
        svg.classList.remove("text-charcoal-300")
        svg.classList.add("text-yellow-500")
      } else {
        // Unfilled state
        svg.classList.remove("text-yellow-500")
        svg.classList.add("text-charcoal-300")
      }
    })
  }
}
